/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total interest`)
};

const es_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interés total`)
};

const de_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtzinsen`)
};

const nl_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale rente`)
};

const fr_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intérêt total`)
};

const it_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interesse totale`)
};

const pt_br2_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juros totais`)
};

const pt_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juros totais`)
};

const ja_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利息合計`)
};

const zh_cp_interest_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总利息`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_interest_out = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_interest_out(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_interest_out", locale)
	if (locale === "en") return en_cp_interest_out(inputs)
	if (locale === "es") return es_cp_interest_out(inputs)
	if (locale === "de") return de_cp_interest_out(inputs)
	if (locale === "nl") return nl_cp_interest_out(inputs)
	if (locale === "fr") return fr_cp_interest_out(inputs)
	if (locale === "it") return it_cp_interest_out(inputs)
	if (locale === "pt-BR") return pt_br2_cp_interest_out(inputs)
	if (locale === "pt") return pt_cp_interest_out(inputs)
	if (locale === "ja") return ja_cp_interest_out(inputs)
	return zh_cp_interest_out(inputs)
};